import {
  Chat,
  ContentRequest,
  Course,
  Lock,
  QuestionMarkOutlined,
  User,
} from "@/components/icons";
import ChartMultiple from "@/components/icons/ChartMultiple";
import Notification from "@/components/icons/Notification";

export const menus = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Upcoming Sessions",
    href: "/course-info",
  },
  {
    label: "FAQs",
    href: "#faq",
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const courseMenus = [
  {
    id: 1,
    label: "My Course",
    href: "/my-course",
    icon: <Course className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 2,
    label: "Test Scores",
    href: "/test-scores",
    icon: <ChartMultiple className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 3,
    label: "Makeup Request",
    href: "/make-up-request",
    icon: (
      <ContentRequest className="size-5.5 transition-colors duration-200" />
    ),
  },
  // {
  //   id: 4,
  //   label: "Support",
  //   icon: <Support className="size-5.5 transition-colors duration-200" />,
  //   rootHref: "/support/faqs",
  //   items: [
  //     {
  //       id: 1,
  //       label: "FAQs",
  //       href: "/support/faqs",
  //       icon: (
  //         <QuestionMarkOutlined className="size-5.5 transition-colors duration-200" />
  //       ),
  //     },
  //   ],
  // },
  {
    id: 4,
    label: "FAQs",
    href: "/faqs",
    icon: (
      <QuestionMarkOutlined className="size-5.5 transition-colors duration-200" />
    ),
  },
  {
    id: 5,
    label: "Chat",
    href: "/chat",
    icon: <Chat className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 6,
    label: "Profile Overview",
    href: "/profile",
    icon: <User className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 7,
    label: "Change Password",
    href: "/change-password",
    icon: <Lock className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 8,
    label: "Notifications Preferences",
    href: "/notifications-preferences",
    icon: <Notification className="size-5.5 transition-colors duration-200" />,
  },
];

export const profilePopUpcourseMenus = [
  {
    id: 1,
    label: "My Course",
    href: "/my-course",
    icon: <Course className="size-5 transition-colors duration-200" />,
  },
  {
    id: 2,
    label: "Test Scores",
    href: "/test-scores",
    icon: <ChartMultiple className="size-5 transition-colors duration-200" />,
  },
  {
    id: 3,
    label: "Makeup Request",
    href: "/make-up-request",
    icon: <ContentRequest className="size-5 transition-colors duration-200" />,
  },
  // {
  //   id: 4,
  //   label: "Support",
  //   icon: <Support className="size-5 transition-colors duration-200" />,
  //   items: [
  //     {
  //       id: 1,
  //       label: "FAQs",
  //       href: "/faqs",
  //       icon: (
  //         <QuestionMarkOutlined className="size-5 transition-colors duration-200" />
  //       ),
  //     },
  //     // {
  //     //   id: 2,
  //     //   label: "Chat",
  //     //   href: "/support/chat",
  //     //   icon: <Chat className="size-5 transition-colors duration-200" />,
  //     // },
  //   ],
  // },
  {
    id: 4,
    label: "FAQs",
    href: "/faqs",
    icon: (
      <QuestionMarkOutlined className="size-5.5 transition-colors duration-200" />
    ),
  },
  {
    id: 5,
    label: "Chat",
    href: "/chat",
    icon: <Chat className="size-5.5 transition-colors duration-200" />,
  },
  {
    id: 6,
    label: "Profile Overview",
    href: "/profile",
    icon: <User className="size-5 transition-colors duration-200" />,
  },

  {
    id: 7,
    label: "Change Password",
    href: "/change-password",
    icon: <Lock className="size-5 transition-colors duration-200" />,
  },
  {
    id: 8,
    label: "Notifications Preferences",
    href: "/notifications-preferences",
    icon: <Notification className="size-5.5 transition-colors duration-200" />,
  },
];

export const mobileCourseMenus = [
  {
    id: 1,
    label: "My Course",
    href: "/my-course",
  },
  {
    id: 2,
    label: "Test Scores",
    href: "/test-scores",
  },
  {
    id: 3,
    label: "Makeup Request",
    href: "/make-up-request",
  },
  {
    id: 4,
    label: "FAQs",
    href: "/faqs",
  },
  {
    id: 5,
    label: "Chat",
    // href: "/support/chat",
    href: "/chat",
  },
  {
    id: 6,
    label: "Profile Overview",
    href: "/profile",
  },

  {
    id: 7,
    label: "Change Password",
    href: "/change-password",
  },
  {
    id: 8,
    label: "Notifications Preferences",
    href: "/notifications-preferences",
    icon: <Notification className="size-5.5 transition-colors duration-200" />,
  },
];
